import React from 'react';
import type { ListingStatsQuery } from '../../../api/services/AdminPanelService';
import type { TopCategoryViewModel } from '../../../api/types/top-category';
import type { CityViewModel } from '../../../api/types/city';
import type { StatusViewModel } from '../../../api/types/status';
import type { SecondaryCategoryViewModel } from '../../../api/types/secondary-category';
import type { ProductTypeViewModel } from '../../../api/types/product-type';

export type ListingStatsFilterState = ListingStatsQuery;

type ListingStatsFiltersProps = {
  filterState: ListingStatsFilterState;
  setFilterState: React.Dispatch<React.SetStateAction<ListingStatsFilterState>>;
  topCategories: TopCategoryViewModel[];
  secondaryCategories: SecondaryCategoryViewModel[];
  productTypes: ProductTypeViewModel[];
  cities: CityViewModel[];
  statuses: StatusViewModel[];
};

const ListingStatsFilters: React.FC<ListingStatsFiltersProps> = ({
  filterState,
  setFilterState,
  topCategories,
  secondaryCategories,
  productTypes,
  cities,
  statuses,
}) => {
  const update = (key: keyof ListingStatsFilterState, value: unknown) => {
    setFilterState((prev) => ({ ...prev, [key]: value === '' || value == null ? undefined : value }));
  };

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="card-title mb-3 text-primary">
          <i className="fas fa-filter me-2" />
          Filtreler
        </h6>
        <div className="row g-2">
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Başlangıç Tarihi</label>
            <input
              type="datetime-local"
              className="form-control form-control-sm"
              value={filterState.StartDate ?? ''}
              onChange={(e) => update('StartDate', e.target.value || undefined)}
            />
          </div>
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Bitiş Tarihi</label>
            <input
              type="datetime-local"
              className="form-control form-control-sm"
              value={filterState.EndDate ?? ''}
              onChange={(e) => update('EndDate', e.target.value || undefined)}
            />
          </div>
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Üst Kategori</label>
            <select
              className="form-select form-select-sm"
              value={filterState.TopCategoryId ?? ''}
              onChange={(e) => update('TopCategoryId', e.target.value ? Number(e.target.value) : undefined)}
            >
              <option value="">Tümü</option>
              {topCategories.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name ?? c.id}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Alt Kategori</label>
            <select
              className="form-select form-select-sm"
              value={filterState.SecondaryCategoryId ?? ''}
              onChange={(e) => update('SecondaryCategoryId', e.target.value ? Number(e.target.value) : undefined)}
            >
              <option value="">Tümü</option>
              {secondaryCategories.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name ?? c.id}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Ürün Tipi</label>
            <select
              className="form-select form-select-sm"
              value={filterState.ProductTypeId ?? ''}
              onChange={(e) => update('ProductTypeId', e.target.value ? Number(e.target.value) : undefined)}
            >
              <option value="">Tümü</option>
              {productTypes.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name ?? p.id}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Şehir</label>
            <select
              className="form-select form-select-sm"
              value={filterState.CityId ?? ''}
              onChange={(e) => update('CityId', e.target.value ? Number(e.target.value) : undefined)}
            >
              <option value="">Tümü</option>
              {cities.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name ?? c.id}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Durum</label>
            <select
              className="form-select form-select-sm"
              value={filterState.StatusId ?? ''}
              onChange={(e) => update('StatusId', e.target.value ? Number(e.target.value) : undefined)}
            >
              <option value="">Tümü</option>
              {statuses.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name ?? s.id}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6 col-lg-3">
            <label className="form-label small">Silinmiş</label>
            <select
              className="form-select form-select-sm"
              value={filterState.IsDeleted === undefined ? '' : String(filterState.IsDeleted)}
              onChange={(e) => {
                const v = e.target.value;
                update('IsDeleted', v === '' ? undefined : v === 'true');
              }}
            >
              <option value="">Tümü</option>
              <option value="false">Hayır</option>
              <option value="true">Evet</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingStatsFilters;
